import { render } from "./EditSocialLink.vue?vue&type=template&id=adef5b52"
import script from "./EditSocialLink.vue?vue&type=script&lang=js"
export * from "./EditSocialLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__